'use client';

import React, { FC } from 'react';
import Layout from '@/src/components/layout/Layout';
import Hero from '@/src/components/sections/hero/Hero';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import AdvantageList from '@/src/components/sections/advantageList/AdvantageList';
import { advInfoHome } from '@/src/lib/staticObjects/advInfo';
import styles from './Home.module.scss';
import HomeCTA from '@/src/components/sections/homeCTA/HomeCTA';
import LatestSection from '@/src/components/sections/latestSection/LatestSection';
import { IFAQ } from '@/src/lib/types/faqInterface';
import FAQSection from '@/src/components/sections/faqSection/FAQSection';
import { ITheme } from '@/src/lib/types/themeInterface';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import { useInView } from 'react-intersection-observer';
import SimpleSubscribe from '@/src/components/sections/simpleSubscribe/SimpleSubscribe';

type THome = {
  faqData: IFAQ[];
  themesData: ITheme[];
};

const Home: FC<THome> = ({ faqData, themesData }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
  });

  const heading = `How Picking Our Themes Pays Off`;

  return (
    <Layout>
      <Hero />
      <LatestSection themesData={themesData} />
      <section className={styles.advantage__section}>
        <Wrapper>
          <div ref={ref}>
            <h2 className={`heading__2 ${styles.heading} ${inView && styles.animate__heading}`}>
              {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
            </h2>
          </div>
          <AdvantageList advList={advInfoHome} />
        </Wrapper>
      </section>
      <FAQSection faqList={faqData} />
      <HomeCTA />
      <SimpleSubscribe />
    </Layout>
  );
};

export default Home;
